import React from "react";
import "./ModalFilter.scss";
// import { CrossIcon } from "../Icons";

import { connectCurrentRefinements } from "react-instantsearch-dom";
import ClearSelection from "../ClearSelection/ClearSelection";
const ClearRefinementsAlgolia = connectCurrentRefinements(ClearSelection);

const includes = (arr, elArray) => {
  if (!arr) {
    return false;
  }

  if (elArray.length === 1) {
    return arr.includes(elArray[0]);
  }

  return elArray.reduce((acc, el) => acc || arr.includes(el), false);
};

const ModalFilter = (TileComponent) => ({active, label, attribute, resetFilters, items, allItems, refine, onChange, onClose}) => {
  let availableItems = items && items.map((i) => i.label);
  let selectedItems = items && items.filter((i) => i.isRefined).map((i) => i.label);
  const valueByName = (c) => items.find((i) => i.label === c).value;


  // Putting this here as ModalFilter.defaultProps does not work with HOC?
  label = label || "No label";
  allItems = allItems || [];
  availableItems = availableItems || [];
  selectedItems = selectedItems || [];
  ////////////

  const className = `modal-filter ${
    active ? "active" : ""
  } modal-filter--${label
    .toLowerCase()
    .split(" ")
    .join("-")}`;

  return (
    <div className={className}>
      <div className="modal-filter__header">
        <button className="modal-filter__close" onClick={onClose}>
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path  fill="currentColor" d='M18 1.799L16.198 0 9 7.201 1.799 0 0 1.799 7.201 9 0 16.198 1.799 18 9 10.8l7.198 7.2L18 16.198 10.8 9 18 1.799z' />
          </svg>
        </button>
        <h3>{label}</h3>
        {selectedItems.length > 0 && (
          <span className="modal-filter__selected-text">
            {selectedItems.length} of {allItems.length} selected
          </span>
        )}
      </div>
      <div className="modal-filter__body">
        {allItems &&
          allItems.map((_c) => {
            const c = Array.isArray(_c) ? _c : [_c];

            const selected = includes(selectedItems, c);
            const disabled = !!(availableItems && !includes(availableItems, c));
            return (
              <TileComponent
                key={c[0]}
                name={c[0]}
                disabled={disabled}
                selected={selected}
                onClick={() => {
                  if (!disabled) {
                    c.forEach((cc) => {
                      refine(valueByName(cc));
                    });
                    if (onChange) {
                      if (includes(selectedItems, c)) {
                        const selectedItemsCopy = [...selectedItems];
                        selectedItemsCopy.splice(
                          selectedItems.indexOf(c[0]),
                          1
                        );
                        onChange(selectedItemsCopy);
                      } else {
                        onChange([...selectedItems, c[0]]);
                      }
                    }
                  }
                }}
              />
            );
          })}
      </div>
      <div className="modal-filter__footer">
        {selectedItems.length > 0 && (
          <ClearRefinementsAlgolia attr={attribute} resetFilters={resetFilters} label="Clear selection" />
        )}
        <button className="btn btn-primary modal-filter__apply" onClick={onClose}>Apply</button>
      </div>
    </div>
  );
};

// propTypes does not work with HOC?

// ModalFilter.propTypes = {
//   active: PropTypes.bool,
//   label: PropTypes.string,
//   attribute: PropTypes.string,
//   items: PropTypes.array,
//   allItems: PropTypes.array,
//   refine: PropTypes.func,
//   onChange: PropTypes.func,
//   onClose: PropTypes.func,
// };

export default ModalFilter;
